import React, { Component } from 'react';
import { Button, Overlay, Popover } from 'react-bootstrap';
import PropTypes from 'prop-types';
import Choice from './Choice';
import CompareModal from './CompareModal';

import './WorkAreaSelect.sass';

export default class WorkAreaSelect extends Component {
  constructor(props) {
    super(props);

    this.selectRef = React.createRef();

    this.state = {
      open: false,
      showCompare: false,
    };
  }

  handleClick = (e) => {
    this.setState({
      target: e.target,
      open: !this.state.open,
    });
  };

  close = () => {
    this.setState({ open: false });
  };

  openCompare = () => {
    this.setState({
      open: false,
      showCompare: true,
    });
  };

  closeCompare = () => {
    this.setState({
      showCompare: false,
    });
  };

  selectChoice = (value) => {
    let event = new Event('change');
    this.selectRef.current.value = value;
    this.selectRef.current.dispatchEvent(event);
    this.props.onChange(event);
    this.setState({ open: false, showCompare: false });
  };

  renderSelected = () => {
    const choice = this.props.choices.find((c) => c.value === this.props.value);
    if (!choice) {
      return null;
    } else {
      return <div>{choice.label}</div>;
    }
  };

  /**
   * Gets a flat array of choices grouped by the 'group' property of each choice, and
   * also includes headers (strings) separating groups
   *
   * @returns {Array}
   */
  getGroupedChoices = () => {
    const grouped = this.props.choices.reduce((acc, cur) => {
      const group = cur.group ? cur.group : '_';
      if (acc.hasOwnProperty(group)) {
        acc[group].push(cur);
      } else {
        acc[group] = [cur];
      }
      return acc;
    }, {});

    let choices = [];
    for (let key in grouped) {
      if (key !== '_') {
        choices.push(key);
      }
      for (let i = 0; i < grouped[key].length; i++) {
        choices.push(grouped[key][i]);
      }
    }
    return choices;
  };

  render() {
    return (
      <div className="workarea-select">
        <div className="current-value" onClick={this.handleClick}>
          {this.renderSelected()}
        </div>
        {this.state.showCompare && (
          <CompareModal
            title={this.props.title}
            choices={this.props.choices}
            selected={this.props.value}
            handleClose={this.closeCompare}
            selectChoice={this.selectChoice}
          />
        )}
        <Overlay
          rootClose
          show={this.state.open}
          target={this.state.target}
          onHide={this.close}
          placement={this.props.panelPosition === 'left' ? 'right' : 'left'}
          popperConfig={{
            modifiers: [
              {
                name: 'preventOverflow',
                options: {
                  boundariesElement: 'viewport',
                },
              },
            ],
          }}
        >
          <Popover
            id={this.props.name + '-choices'}
            className="workarea-select-popover"
          >
            <Popover.Header>
              <div className="d-flex justify-content-between">
                <span>{this.props.title}</span>
                <Button
                  variant="outline-primary"
                  size="sm"
                  onClick={this.openCompare}
                >
                  Compare
                </Button>
              </div>
            </Popover.Header>
            <Popover.Body>
              <ul className="choices">
                {this.getGroupedChoices().map((c) => {
                  if (typeof c === 'string') {
                    // this is a group heading
                    return (
                      <li key={c} className="heading">
                        {c}
                      </li>
                    );
                  } else {
                    return (
                      <Choice
                        key={c.value}
                        choice={c}
                        isSelected={c.value === this.props.value}
                        panelPosition={this.props.panelPosition}
                        handleSelect={this.selectChoice}
                      />
                    );
                  }
                })}
              </ul>
            </Popover.Body>
          </Popover>
        </Overlay>
        <select
          name={this.props.name}
          value={this.props.value}
          disabled={this.props.disabled}
          ref={this.selectRef}
          onChange={() => {}}
        >
          {this.props.choices.map((c) => (
            <option key={c.value} value={c.value}>
              {c.label}
            </option>
          ))}
        </select>
      </div>
    );
  }
}

WorkAreaSelect.propTypes = {
  choices: PropTypes.arrayOf(PropTypes.object),
  value: PropTypes.string,
  disabled: PropTypes.bool,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  title: PropTypes.string,
  panelPosition: PropTypes.string,
};

WorkAreaSelect.defaultProps = {
  choices: [],
  value: '',
  disabled: false,
  onChange: () => {},
  title: '',
  panelPosition: 'left',
};
